import LTR from "@brand-icons/ploom/ui-earth-outline/ui-earth-outline-ltr.svg";

import { iconFactory } from "../iconFactory";

export const UiEarthOutlineIcon = iconFactory("UiEarthOutlineIcon", LTR);
